import type { SVGProps } from "react";

/** E-Challan Summary sidebar nav icon (Figma). Uses `currentColor` for theme-driven fill. */
export const EChallanSummaryNavIcon = ({ className, ...props }: SVGProps<SVGSVGElement>) => (
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={className}
		aria-hidden
		{...props}
	>
		<path
			d="M5.5 2.5H12.0858C12.351 2.5 12.6054 2.60536 12.7929 2.79289L16.2071 6.20711C16.3946 6.39464 16.5 6.649 16.5 6.91421V15.5C16.5 16.6046 15.6046 17.5 14.5 17.5H5.5C4.39543 17.5 3.5 16.6046 3.5 15.5V4.5C3.5 3.39543 4.39543 2.5 5.5 2.5Z"
			stroke="currentColor"
			strokeWidth="1.25"
		/>
		<path d="M8 7.5H12.5" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
		<path d="M8 10.5H12.5" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
		<path
			d="M4.75 15.5H15.25L14 17.5H6L4.75 15.5Z"
			fill="currentColor"
		/>
	</svg>
);
